window.HGW = window.HGW || {};

HGW.state = {

  /* =========================
     Default State
  ========================= */

  default() {
    return {
      step: 1,
      method: "",

      // Pickup
      store: "",
      date: "",
      time: "",
      note: "",

      // Delivery (Single Source of Truth)
      delivery: {
        address: "",
        suburb: "",
        postcode: "",

        store_code: "",
        store_name: "",

        lat: "",
        lng: "",

        calc_key: "",
        calc_status: "idle",
        calc_error: "",

        is_metro: null,
        area_label: "",

        parcel_count: 0,
        base_shipping_cost: 0,
        final_shipping_cost: 0,

        distance_km: "",
        eta_min: "",
        provider: "",

        policy_agreed: false,
        dispatch_date: "",

        signature_required: false,
        signature_fee: 1.75,

        eta_text: ""
      }
    };
  },

  /* =========================
     Internal Helpers
  ========================= */

  _safeObject(v) {
    return v && typeof v === "object" ? v : {};
  },

  _mergeDelivery(current, next) {
    return {
      ...this._safeObject(current),
      ...this._safeObject(next)
    };
  },

  _persist(state) {
    window.HGWState?.set?.(state);
  },

  _loadPersisted() {
    return window.HGWState?.get?.() || null;
  },

  _hasMeaningfulState(state) {
    if (!state || typeof state !== "object") return false;

    const d = state.delivery || {};

    return Boolean(
      state.method ||
      state.store ||
      state.date ||
      state.time ||
      state.note ||
      d.address ||
      d.suburb ||
      d.postcode ||
      d.store_code ||
      d.store_name ||
      d.dispatch_date ||
      d.calc_key
    );
  },

  rehydrateFromPersisted() {
    const persisted = this._safeObject(this._loadPersisted());
    if (!this._hasMeaningfulState(persisted)) return false;

    const base = this.default();

    this.data = {
      ...base,
      ...persisted,
      delivery: this._mergeDelivery(base.delivery, persisted.delivery)
    };

    return true;
  },

  /* =========================
     Init (only once)
  ========================= */

  init() {
    const base = this.default();
    const persisted = this._safeObject(this._loadPersisted());

    this.data = {
      ...base,
      ...persisted,
      delivery: this._mergeDelivery(base.delivery, persisted.delivery)
    };

    if (this._hasMeaningfulState(persisted)) {
      this._persist(this.data);
    }
  },

  /* =========================
     Update
  ========================= */

  update(partial = {}) {
    if (!partial || typeof partial !== "object") return;

    if (!this._hasMeaningfulState(this.data)) {
      this.rehydrateFromPersisted();
    }

    const next = { ...this.data };

    if (partial.delivery) {
      next.delivery = this._mergeDelivery(next.delivery, partial.delivery);
    }

    const { delivery, ...rest } = partial;
    Object.assign(next, rest);

    this.data = next;
    this._persist(this.data);
  },

  /* =========================
     Get (NO MERGE, PURE RETURN)
  ========================= */

  get() {
    if (!this._hasMeaningfulState(this.data)) {
      this.rehydrateFromPersisted();
    }
    return this.data;
  },

  /* =========================
     Reset
  ========================= */

  reset() {
    this.data = this.default();
    this._persist(this.data);
  }
};

/* =========================
   Initialize
========================= */

HGW.state.init();

window.addEventListener("pageshow", function () {
  HGW.state.rehydrateFromPersisted();
});